import React from "react";
import { Typography, Button, Container, Paper, Stack } from "@mui/material";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

const logErrorToService = (error: Error, errorInfo: React.ErrorInfo) => {
  console.error("catch error:", { error, errorInfo });
};

type Props = {
  children: React.ReactNode;
};

type State = {
  hasError: boolean;
  error: Error | null;
};

export class ErrorBoundary extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error: Error): State {
    return { hasError: true, error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    logErrorToService(error, info);
  }

  handleReload = () => {
    window.location.reload();
  };

  render(): React.ReactNode {
    const { hasError, error } = this.state;
    if (hasError) {
      return (
        <Container maxWidth="sm" sx={{ mt: 10 }}>
          <Paper elevation={3} sx={{ textAlign: "center", p: 4 }}>
            <Stack spacing={2} alignItems={"center"}>
              <ErrorOutlineIcon color="error" sx={{ fontSize: 60 }} />
              <Typography variant="h5">エラーが発生しました</Typography>
              <Typography variant="body1" sx={{ mb: 3 }}>
                大変申し訳ありません。
                <br />
                一時的な問題が発生しています。
              </Typography>
              <Button
                variant="contained"
                color="error"
                onClick={this.handleReload}
              >
                再読み込み
              </Button>
              {process.env.NODE_ENV === "development" && error && (
                <pre style={{ whiteSpace: "pre-wrap", marginTop: 16 }}>
                  DEBUG:
                  <br />
                  {error.message}
                </pre>
              )}
            </Stack>
          </Paper>
        </Container>
      );
    }

    return this.props.children;
  }
}
